/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


define(['./APIEventSupport'], (APIEventSupport) => {
	class APIExtension {

		static getAPIExtension(implementation){
			if (!implementation.__apiExtension) {
				implementation.__apiExtension = new APIExtension(implementation);
			}
			return implementation.__apiExtension;
		}

		constructor(apiImplementation) {
			this.apiImplementation = apiImplementation;
			this.apiExtensions = {};
			let apiSpec;
			if (typeof (apiImplementation.getAPISpec) === 'function') {
				apiSpec = apiImplementation.getAPISpec();
			}
			// register extension based on the categories in the api spec
			if (apiSpec) {
				let category;
				for (category in apiSpec) {
					const apiExtension = this.createExtension(apiImplementation, category, apiSpec.events, apiSpec.name,  apiSpec.features);
					if (apiExtension) {
						this.apiExtensions[category] = apiExtension;
						// API extension exists so need to create extension functions in APIFactory.
						this._enabled = true;
					}
				}
			}
		}

		extendAPI(apiInstance, apiInterface){
			let name;
			for (name in this.apiExtensions) {
				if (this.apiExtensions[name].extendAPI){
					this.apiExtensions[name].extendAPI(apiInstance, apiInterface);
				}
			}
		}

		createExtension(apiImplementation, category, spec, name, features) {
			// We currently only support events in the api spec
			if (category === 'events') {
				return new APIEventSupport(apiImplementation, spec, name, features);
			}
		}

		/**
		 * @return true if any entry exists in this.apiExtensions.
		 * Used to indicate extension functions are required when create functions in APIFactory
		 */
		isEnabled() {
			return !!this._enabled;
		}

		getSupport(name) {
			return this.apiExtensions[name];
		}

		isSupported(functionName){
			for (let name in this.apiExtensions) {
				if (this.apiExtensions[name].isSupported(functionName)){
					return true;
				}
			}
			return false;
		}

		onBeforeAction(actionName, args, apiContext) {
			const options = {};
			let name;
			for (name in this.apiExtensions) {
				options[name] = this.apiExtensions[name].onBeforeAction(actionName, args, apiContext);
			}
			return options;
		}

		onAfterAction(actionName, args, returnValue, onBeforeActionOptions, apiContext) {
			let name;
			for (name in this.apiExtensions) {
				onBeforeActionOptions[name] = this.apiExtensions[name].onAfterAction(actionName, args, returnValue, onBeforeActionOptions[name], apiContext);
			}
		}

	}

	return APIExtension;
});
